import { render, staticRenderFns } from "./TermosServico.vue?vue&type=template&id=05fa0673&"
import script from "./TermosServico.vue?vue&type=script&lang=js&"
export * from "./TermosServico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports